const __request = require(`./__request/__request_contentType_json`)
const request = (data) => {
    let pParameter = {
        method: 'post',
        urlSuffix: 'buyer/dom/white/luggage',
        data: data
    }
    return __request(pParameter)
}
export default request